

import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";

function ChangeLang({ onSearch, isDarkMode, onToggleTheme }) {
  const [showInput, setShowInput] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const ref = useRef(null);

  const { i18n } = useTranslation();

  // فتح وغلق input البحث
  const openInput = () => {
    setShowInput(true);
    setTimeout(() => ref.current?.focus(), 100);
  };
  const closeInput = () => {
    setShowInput(false);
    setSearchTerm("");
    onSearch("");
  };

  const handleInputChange = (e) => {
    const val = e.target.value;
    setSearchTerm(val);
    onSearch(val);
  };

  // تغيير اللغة
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    document.dir = lng === "ar" ? "rtl" : "ltr";
  };

  // ألوان حسب الوضع
  const styles = {
    dark: {
      background: "#000",
      textColor: "#FFC107",
      borderColor: "#FFC107",
      inputBg: "#3b252576",
      inputText: "#FFC107",
      shadow: "0 0 1px #ffc800",
      iconBg: "#FFC107",
      iconColor: "#000",
      selectBg: "#00000058",
      hoverBg: "#1a1a1a",
    },
    light: {
      background: "#f8f9fa",
      textColor: "#e67e22",
      borderColor: "#e67e22",
      inputBg: "#ffffff",
      inputText: "#2c3e50",
      shadow: "0 0 1px #e67e22",
      iconBg: "#e67e22",
      iconColor: "#fff",
      selectBg: "#f8f9fa",
      hoverBg: "#e9ecef",
    },
  };

  const currentStyle = isDarkMode ? styles.dark : styles.light;

  // ستايل موحد للأزرار
  const buttonStyle = {
    borderRadius: "8px",
    padding: "10px 15px",
    fontSize: "16px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: "bold",
    transition: "all 0.3s ease",
    border: `1px solid ${currentStyle.borderColor}`,
    minWidth: "55px",
  };

  return (
    <div
      className="fixed-top w-100 pt-1"
      style={{
        backgroundColor: currentStyle.background,
        zIndex: 900000,
        boxShadow: currentStyle.shadow,
        transition: "all 0.3s ease",
        backdropFilter: "blur(10px)",
      }}
    >
      <div className="container d-flex justify-content-between align-items-center py-2">
        {/* الأزرار الرئيسية */}
        <div className="d-flex align-items-center gap-2">
          {/* Theme toggle */}
          <button
            onClick={onToggleTheme}
            className="shadow"
            style={{
              ...buttonStyle,
              backgroundColor: currentStyle.iconBg,
              color: currentStyle.iconColor,
              width: "45px",
              height: "45px",
              fontSize: "18px",
            }}
            title={isDarkMode ? "Switch to Light Mode" : "Switch to Dark Mode"}
          >
            {isDarkMode ? "☀️" : "🌙"}
          </button>

          {/* Language select */}
          <select
            onChange={(e) => changeLanguage(e.target.value)}
            value={i18n.language}
            className="shadow"
            style={{
              ...buttonStyle,
              backgroundColor: currentStyle.selectBg,
              color: currentStyle.textColor,
              padding: "10px",
              appearance: "none",
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = currentStyle.hoverBg;
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = currentStyle.selectBg;
            }}
          >
            <option value="en">EN</option>
            <option value="ar">AR</option>
            <option value="de">DE</option>
          </select>

          {/* AT button */}
          <a
            href="/AT.pdf"
            target="_blank"
            className="shadow d-block"
            style={{
              ...buttonStyle,
              backgroundColor: isDarkMode ? "#000000" : "#fff",
              color: isDarkMode ? "#e6a122ff" : "#e67e22",
              border: isDarkMode ? "1px solid #e4c63fff" : "1px solid #e67e22",
              padding: "10px 15px",
            }}
          >
            AT
            <span className={`${showInput ? "d-none" : "mx-1"}`}>🌾</span>
          </a>
        </div>

        {/* Search input */}
        <div
          className={`${
            showInput ? "d-flex" : "d-none"
          } align-items-center position-relative flex-grow-1 mx-2`}
        >
          <input
            ref={ref}
            type="text"
            value={searchTerm}
            onChange={handleInputChange}
            className="w-100"
            style={{
              padding: "8px 20px",
              fontSize: "16px",
              borderRadius: "8px",
              border: `2px solid ${currentStyle.borderColor}`,
              backgroundColor: currentStyle.inputBg,
              color: currentStyle.inputText,
              boxSizing: "border-box",
              outline: "none",
              transition: "all 0.3s ease",
              fontWeight: 500,
            }}
            placeholder={
              i18n.language === "ar"
                ? "ابحث..."
                : i18n.language === "de"
                ? "Suchen..."
                : "Search..."
            }
          />
          <i
            onClick={closeInput}
            className="fa-regular fa-circle-xmark position-absolute"
            style={{
              cursor: "pointer",
              right: "15px",
              top: "50%",
              transform: "translateY(-50%)",
              fontSize: "22px",
              transition: "all 0.3s ease",
              color: currentStyle.textColor,
            }}
          ></i>
        </div>

        {/* Search icon */}
        <div className={`icon position-relative ${showInput ? "d-none" : ""}`}>
          <i
            onClick={openInput}
            className="fa-solid fa-magnifying-glass fs-4 border shadow"
            style={{
              cursor: "pointer",
              color: currentStyle.textColor,
              transition: "all 0.3s ease",
              padding: "10px",
              borderRadius: "8px",
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = currentStyle.hoverBg;
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "transparent";
            }}
            title={
              i18n.language === "ar"
                ? "بحث"
                : i18n.language === "de"
                ? "Suche"
                : "Search"
            }
          ></i>
        </div>
      </div>
    </div>
  );
}

export default ChangeLang;
